module.exports = __webpack_public_path__ + "img/vambrace_strength.901f9000.png";